import {Component, OnInit, ViewChild} from '@angular/core';
import {BaseComponent} from '../../modules/shared/components/base.component';
import {NavigationEnd, Router} from '@angular/router';
import {UserPreferencesService} from '../../modules/shared/service/user-preferences.service';
import {AuthorizationService} from '../../modules/shared/service/authorization.service';
import { environment } from '../../../environments/environment';
import {ApplicationConfig} from '../../config/application.config';
import {TokenService} from '../../service/token.service';
import {Location} from '@angular/common';
import { AppsListComponent } from '@npm.chapps.com/chapps.common.angular.library';
import {ChappsAccountService} from '../../modules/shared/service/chapps-account.service';
import { LocalizationService } from 'src/app/modules/shared/service/localization.service';
import {FeatureService} from "../../modules/shared/service/feature.service";

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent extends BaseComponent implements OnInit {



  @ViewChild(AppsListComponent, {static: true}) appsListComponent: AppsListComponent;
  public logoUrl: string;
  public userName: string;
  public userEmail: string;
  public isDashboardButtonActive: boolean;
  public isDocumentsButtonActive: boolean;
  public isAccountButtonActive: boolean;
  public isNotificationsButtonActive: boolean;
  public isResidentsButtonActive: boolean;
  public isAnnouncementsButtonActive: boolean;
  public isBusinessStyleButtonActive: boolean;
  public isLoginsButtonActive: boolean;
  public areSettingsActive: boolean;
  public zendeskUrl: string;

  constructor(private router: Router, private userPreferencesService: UserPreferencesService, private authService: AuthorizationService,
              public config: ApplicationConfig, private tokenService: TokenService, private location: Location,
              private applicationConfig: ApplicationConfig, private chappsAccountService: ChappsAccountService, private localizationService: LocalizationService,
              public features: FeatureService) {
    super();
    this.zendeskUrl = environment.zendeskUrl;
  }

  ngOnInit() {
    this.logoUrl = this.userPreferencesService.getCompanyLogoUrl();
    this.userEmail = this.tokenService.getUsername();
    this.userName = `${this.tokenService.getFirstName()} ${this.tokenService.getLastName()}`;
    this.resetButtons();
    this.selectButtonDependingOfRoute(this.router.url);
    this.selectListItemDependingOnRoute(this.router.url);
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.selectButtonDependingOfRoute(event.url);
        this.selectListItemDependingOnRoute(event.url);
      }
    });
    this.appsListComponent.init(this.chappsAccountService.getApplications());

  }

  public goBack() {
    this.location.back();
  }

  public showBackButton(): boolean {
    return this.isScreenNarrowEnoughForBackButton() && this.doShowBackButtonOnCurrentUrl();
  }



  public selectButtonDependingOfRoute(url: string) {
    this.isDashboardButtonActive = url.includes('dashboard');
    this.isDocumentsButtonActive = url.includes('documents');
    this.isAccountButtonActive = url.includes('account');
    this.isNotificationsButtonActive = url.includes('notifications');
    this.isResidentsButtonActive = url.includes('residents');
    this.isAnnouncementsButtonActive = url.includes('announcements');
    this.isBusinessStyleButtonActive = url.includes('businessstyle');
    this.isLoginsButtonActive = url.includes('logins');

    this.areSettingsActive = this.isLoginsButtonActive || this.isBusinessStyleButtonActive;
  }

  public selectListItemDependingOnRoute(url: string) {
  }

  public logout() {
    this.authService.clearSession();
    window.location.href = environment.accountSiteUrl + 'signout?application=Residenz';
  }

  public goToAccount() {
    window.location.href = environment.accountSiteUrl + 'dashboard';
  }

  private resetButtons() {
    this.isDashboardButtonActive = false;
    this.isDocumentsButtonActive = false;
    this.isAccountButtonActive = false;
    this.isNotificationsButtonActive = false;
    this.isResidentsButtonActive = false;
    this.isAnnouncementsButtonActive = false;
    this.isBusinessStyleButtonActive = false;
    this.isLoginsButtonActive = false;

    this.areSettingsActive = false;
  }

  private isScreenNarrowEnoughForBackButton(): boolean {
    return window.screen.width <= this.applicationConfig.MAX_RESOLUTION_TO_SHOW_BACK_BUTTON;
  }

  private doShowBackButtonOnCurrentUrl(): boolean {
    return this.applicationConfig.BACK_BUTTON_REGEXP_PAGES.some(r => this.router.url.match(r) != null);
  }
}
